import React, { useState } from "react";
import OrgDesignRoleBoxNode from "./OrgDesignRoleBoxNode";
import { summarizeSubtreeStatuses } from "../orgDesignTreeEngine";

// Collapse state is local to each node instance — no cross-node interaction
// is required, so there's no need to lift it into shared state. It resets
// to expanded on remount (e.g. reopening a version), which is the expected
// default.
const OrgDesignChartNode = ({ node, editable, onEdit, roles, newRoles, entryOption }) => {
  const [collapsed, setCollapsed] = useState(false);
  const hasChildren = node.ch?.length > 0;
  const changeSummary = collapsed && hasChildren ? summarizeSubtreeStatuses(node) : null;

  return (
    <li>
      <OrgDesignRoleBoxNode
        node={node}
        editable={editable}
        onEdit={onEdit}
        roles={roles}
        newRoles={newRoles}
        hasChildren={hasChildren}
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed((c) => !c)}
        changeSummary={changeSummary}
        entryOption={entryOption}
      />
      {hasChildren && !collapsed && (
        <ul>
          {node.ch.map((child) => (
            <OrgDesignChartNode key={child.id} node={child} editable={editable} onEdit={onEdit} roles={roles} newRoles={newRoles} entryOption={entryOption} />
          ))}
        </ul>
      )}
    </li>
  );
};

export default OrgDesignChartNode;
